
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/adyar",
      function () {
        return require("private-next-pages/adyar/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/adyar"])
      });
    }
  